<template>
  <div class="my-l">
    <iframe :src="iframeUrl" :height="iHeight" class="border-0 w-full" :title="$t('jobs.iframeTitle')" />
  </div>
</template>

<script>
import gql from 'graphql-tag';

export default defineNuxtComponent({
  props: {
    iframeUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return { iHeight: '100%' };
  },
  mounted() {
    window.addEventListener('message', this.setHeight);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.setHeight);
  },
  methods: {
    setHeight(e) {
      const eventName = e.data[0];
      const data = e.data[1];
      if (data) {
        this.iHeight = eventName === 'setHeight' ? data + 'px' : '100%';
      }
    },
  },
});
</script>
